const classNames = {
  wrapper: 'swiper-wrapper',
  slide: 'swiper-slide',
  slidePrev: 'swiper-slide-prev',
  slideActive: 'swiper-slide-active',
  slideNext: 'swiper-slide-next',
  navigationButtonPrev: 'swiper-button-prev',
  navigationButtonNext: 'swiper-button-next',
  navigationButtonDisabled: 'swiper-button-disabled',
  navigationButtonHidden: 'swiper-button-hidden',
  navigationButtonLock: 'swiper-button-lock',
}

export default classNames
